import { z } from "zod";
import { runCycleMonthSchema } from "@/features/payroll/run-cycle-months";

/// URL search params for `/$workspaceSlug/payroll/inputs` (PAYD-FR-001).
///
/// `month`, `q`, `group` and `status` ride the URL (S3): "December, recovery
/// rows only" is a link an admin sends a colleague. `row` opens one row's edit
/// dialog, the same way `member` opens a drawer on the salaries grid, so a
/// link to "this one adjustment" is also a link somebody can send. Adding a
/// row, opening the import wizard and opening the overrides drawer stay off
/// the URL: they are entry points, not content, the same way the salaries
/// grid's paste dialog is local state.
///
/// An unrecognised value normalizes to undefined rather than refusing the
/// page: a stale bookmark should land somebody on the grid, not on an error.
export const payrollInputsRouteSearchSchema = z
  .object({
    month: runCycleMonthSchema.optional().catch(undefined),
    q: z.string().optional().catch(undefined),
    group: z.string().optional().catch(undefined),
    status: z.enum(["active", "cancelled"]).optional().catch(undefined),
    row: z.string().optional().catch(undefined),
  })
  .strict();

export type PayrollInputsRouteSearch = z.infer<typeof payrollInputsRouteSearchSchema>;
